"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _radio = _interopRequireDefault(require("britive-design-system/core/components/radio"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("react-datepicker/dist/react-datepicker.css");

var _textfield = _interopRequireDefault(require("britive-design-system/core/components/textfield"));

var _modalPopup = _interopRequireDefault(require("britive-design-system/core/components/modal-popup"));

var _commonUtils = require("../../../../../utils/common-utils");

var _constants = require("./constants");

var _lodash = require("lodash");

var _commonConstants = require("../../../../../utils/common-constants");

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _table = _interopRequireDefault(require("britive-design-system/core/components/table"));

var _tooltip = _interopRequireDefault(require("britive-design-system/core/components/tooltip"));

var _edit = _interopRequireDefault(require("../../../../../assets/edit.svg"));

var _infoIcon = _interopRequireDefault(require("../../../../../assets/infoIcon.svg"));

var _actions = require("../../../../../components/policy/notificationMedium/actions");

var _reactRedux = require("react-redux");

var _NotificationMediumSelector = _interopRequireDefault(require("./NotificationMediumSelector"));

var _utils = require("./utils");

var _AddIdentities = _interopRequireDefault(require("../members-tab/add-users/AddIdentities"));

var _DataTable = _interopRequireDefault(require("../../../../data-table/DataTable"));

var _bs = require("react-icons/bs");

var _AddTags = _interopRequireDefault(require("../members-tab/tags/AddTags"));

var _fa = require("react-icons/fa");

var _TagMembers = _interopRequireDefault(require("../members-tab/tags/TagMembers"));

var _actions2 = require("../../../../policy/Members/actions");

var _index = _interopRequireDefault(require("../../../../PillListTableColumn/index"));

var _checkbox = _interopRequireDefault(require("britive-design-system/core/components/checkbox"));

var _SectionTitle = _interopRequireDefault(require("../../../../SectionTitle"));

var _dialog = _interopRequireDefault(require("britive-design-system/core/components/dialog"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.policy-approval-tab-main-container {\n  flex-grow: 1;\n  padding-top: 3rem;\n  padding-left: 3.5rem;\n  padding-bottom: 3rem;\n  padding-right: 2rem;\n  overflow: auto; }\n  .policy-approval-tab-main-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .policy-approval-tab-main-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .policy-approval-tab-main-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .policy-approval-tab-main-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n  .policy-approval-tab-main-container .sm-form-name-loader-wrapper {\n    display: flex;\n    align-items: center; }\n    .policy-approval-tab-main-container .sm-form-name-loader-wrapper .sm-form-name-check-loader {\n      margin-top: 1.25rem;\n      margin-left: 0.625rem; }\n  .policy-approval-tab-main-container .sm-add-policy-field-wrapper {\n    margin-bottom: 2rem; }\n  .policy-approval-tab-main-container .sm-add-policy-field-value-wrapper {\n    margin-top: 0.5rem; }\n  .policy-approval-tab-main-container .sm-value-wrapper {\n    margin-top: 0.625rem; }\n  .policy-approval-tab-main-container .sm-table-container {\n    margin-top: 0.5rem;\n    max-height: 20rem;\n    overflow-y: scroll; }\n  .policy-approval-tab-main-container .action-icon {\n    cursor: pointer; }\n    .policy-approval-tab-main-container .action-icon-edit {\n      height: 1.5rem; }\n  .policy-approval-tab-main-container .action-icons-container {\n    display: flex;\n    justify-content: flex-start;\n    gap: 0.5rem; }\n  .policy-approval-tab-main-container .info-icon {\n    display: flex;\n    align-items: center;\n    gap: 0.3125rem; }\n    .policy-approval-tab-main-container .info-icon img {\n      height: 1.125rem; }\n";
  var fileName = "compone_AddApprovalTab";
  var element = document.querySelector("style[data-sass-component='compone_AddApprovalTab']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  },
  fieldContainer: {
    marginBottom: '8px'
  }
};

var Approvals = function Approvals(_ref) {
  var validationHook = _ref.validationHook,
      usersDataStatus = _ref.usersDataStatus,
      groupsDataStatus = _ref.groupsDataStatus,
      initSpinnerOverlay = _ref.initSpinnerOverlay,
      notificationMediumStatus = _ref.notificationMediumStatus,
      notificationMediumData = _ref.notificationMediumData,
      translatedStrings = _ref.translatedStrings,
      consumer = _ref.consumer,
      isFromAllSecrets = _ref.isFromAllSecrets,
      openNotification = _ref.openNotification;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      notificationMediumOptions = _useState2[0],
      setNotificationMediumOptions = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      resourcesLoading = _useState4[0],
      setResourcesLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isDrawerOpen = _useState6[0],
      setIsDrawerOpen = _useState6[1];

  var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      currentEditingMedium = _useState8[0],
      setCurrentEditingMedium = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      selectionError = _useState10[0],
      setSelectionError = _useState10[1];

  var _useState11 = (0, _react.useState)([]),
      _useState12 = _slicedToArray(_useState11, 2),
      selectedNotificationMediums = _useState12[0],
      setSelectedNotificationMediums = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      addUsersModalVisibility = _useState14[0],
      setAddUsersModalVisibility = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      addTagModalVisibility = _useState16[0],
      setAddTagModalVisibility = _useState16[1];

  var _useState17 = (0, _react.useState)(null),
      _useState18 = _slicedToArray(_useState17, 2),
      membersTagId = _useState18[0],
      setMembersTagId = _useState18[1];

  var _useState19 = (0, _react.useState)(null),
      _useState20 = _slicedToArray(_useState19, 2),
      membersModalTitle = _useState20[0],
      setMembersModalTitle = _useState20[1];

  var _useState21 = (0, _react.useState)(false),
      _useState22 = _slicedToArray(_useState21, 2),
      dialogOpen = _useState22[0],
      setDialogOpen = _useState22[1];

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    var _state$secretsReducer, _state$policyReducer;

    return isFromAllSecrets ? state === null || state === void 0 ? void 0 : (_state$secretsReducer = state.secretsReducer) === null || _state$secretsReducer === void 0 ? void 0 : _state$secretsReducer.validateChannelsReducer : state === null || state === void 0 ? void 0 : (_state$policyReducer = state.policyReducer) === null || _state$policyReducer === void 0 ? void 0 : _state$policyReducer.validateChannelsReducer;
  }),
      validateChannelListStatus = _useSelector.status,
      validateChannelListError = _useSelector.error;

  var approvalValidityInfoMessage = 'The amount of time the approval is valid for, the approval will not be required for subsequent checkout within this timeframe.';
  var maximumTimeToApproveInfoMessage = 'The amount of time an approver has to approve the request before it expires.';
  (0, _react.useEffect)(function () {
    if ((0, _commonUtils.isSuccess)(notificationMediumStatus) && !(0, _lodash.isEmpty)(notificationMediumData)) {
      setNotificationMediumOptions(notificationMediumData);
    }

    if ((0, _commonUtils.isLoading)(usersDataStatus) || (0, _commonUtils.isLoading)(groupsDataStatus) || (0, _commonUtils.isLoading)(notificationMediumStatus)) {
      setResourcesLoading(true);
    }

    if ((0, _commonUtils.isError)(usersDataStatus) || (0, _commonUtils.isError)(groupsDataStatus) || (0, _commonUtils.isError)(notificationMediumStatus)) {
      setResourcesLoading(false);
    }

    if (!(0, _commonUtils.isLoading)(usersDataStatus) && !(0, _commonUtils.isLoading)(groupsDataStatus) && !(0, _commonUtils.isLoading)(notificationMediumStatus)) {
      setResourcesLoading(false);
    }
  }, [usersDataStatus, groupsDataStatus, notificationMediumStatus]);
  (0, _react.useEffect)(function () {
    initSpinnerOverlay({
      open: resourcesLoading,
      size: _commonConstants.medium,
      message: translatedStrings.loadingMembers
    });
  }, [resourcesLoading]);
  (0, _react.useEffect)(function () {
    if ((0, _commonUtils.isError)(validateChannelListStatus)) setSelectionError(validateChannelListError);

    if ((0, _commonUtils.isSuccess)(validateChannelListStatus)) {
      openNotification('success', 'Slack channel(s) validated.', 3000);
    }
  }, [validateChannelListStatus, validateChannelListError]);

  var massageChannels = function massageChannels() {
    var _validationHook$value, _validationHook$value2, _validationHook$value3, _validationHook$value4, _validationHook$value9;

    if (!(0, _lodash.isEmpty)(validationHook === null || validationHook === void 0 ? void 0 : (_validationHook$value = validationHook.values) === null || _validationHook$value === void 0 ? void 0 : _validationHook$value.channelList) || !(0, _lodash.isEmpty)(validationHook === null || validationHook === void 0 ? void 0 : (_validationHook$value2 = validationHook.values) === null || _validationHook$value2 === void 0 ? void 0 : _validationHook$value2.slackAppChannels) || !(0, _lodash.isEmpty)(validationHook === null || validationHook === void 0 ? void 0 : (_validationHook$value3 = validationHook.values) === null || _validationHook$value3 === void 0 ? void 0 : _validationHook$value3.teamsAppChannels) || !(0, _lodash.isEmpty)(validationHook === null || validationHook === void 0 ? void 0 : (_validationHook$value4 = validationHook.values) === null || _validationHook$value4 === void 0 ? void 0 : _validationHook$value4.notificationMedium)) {
      var _validationHook$value5;

      var list = validationHook === null || validationHook === void 0 ? void 0 : (_validationHook$value5 = validationHook.values) === null || _validationHook$value5 === void 0 ? void 0 : _validationHook$value5.notificationMedium;
      var notificationDetails = list === null || list === void 0 ? void 0 : list.map(function (ele) {
        if ((ele === null || ele === void 0 ? void 0 : ele.type) === 'slack') {
          var _validationHook$value6;

          return _objectSpread(_objectSpread({}, ele), {}, {
            channels: validationHook === null || validationHook === void 0 ? void 0 : (_validationHook$value6 = validationHook.values) === null || _validationHook$value6 === void 0 ? void 0 : _validationHook$value6.channelList
          });
        }

        if ((ele === null || ele === void 0 ? void 0 : ele.type) === _constants.formConstants.slackbotText) {
          var _validationHook$value7;

          return _objectSpread(_objectSpread({}, ele), {}, {
            channels: validationHook === null || validationHook === void 0 ? void 0 : (_validationHook$value7 = validationHook.values) === null || _validationHook$value7 === void 0 ? void 0 : _validationHook$value7.slackAppChannels
          });
        }

        if ((ele === null || ele === void 0 ? void 0 : ele.type) === _constants.formConstants.teamsbotText) {
          var _validationHook$value8;

          return _objectSpread(_objectSpread({}, ele), {}, {
            teamsAppChannels: validationHook === null || validationHook === void 0 ? void 0 : (_validationHook$value8 = validationHook.values) === null || _validationHook$value8 === void 0 ? void 0 : _validationHook$value8.teamsAppChannels
          });
        }

        return ele;
      });
      return notificationDetails;
    }

    return (validationHook === null || validationHook === void 0 ? void 0 : (_validationHook$value9 = validationHook.values) === null || _validationHook$value9 === void 0 ? void 0 : _validationHook$value9.notificationMedium) || [];
  };

  (0, _react.useEffect)(function () {
    setSelectedNotificationMediums(massageChannels());
  }, []);
  (0, _react.useEffect)(function () {
    if (!(0, _lodash.isEmpty)(selectedNotificationMediums)) {
      validationHook.handleChange(validationHook.names.notificationMedium, selectedNotificationMediums);
    }

    var slackMedium = !(0, _lodash.isEmpty)(selectedNotificationMediums) && selectedNotificationMediums.find(function (element) {
      return element.type === "slack";
    });
    var slackBotMedium = !(0, _lodash.isEmpty)(selectedNotificationMediums) && selectedNotificationMediums.find(function (element) {
      return element.type === "slackapp";
    });
    var teamsBotMedium = !(0, _lodash.isEmpty)(selectedNotificationMediums) && selectedNotificationMediums.find(function (element) {
      return element.type === "teamsapp";
    });

    if (slackMedium && !(0, _lodash.isEmpty)(slackMedium)) {
      validationHook.handleChange(validationHook.names.channelList, (slackMedium === null || slackMedium === void 0 ? void 0 : slackMedium.channels) || []);
    } else {
      validationHook.handleChange(validationHook.names.channelList, []);
    }

    if (slackBotMedium && !(0, _lodash.isEmpty)(slackBotMedium)) {
      validationHook.handleChange(validationHook.names.slackAppChannels, (slackBotMedium === null || slackBotMedium === void 0 ? void 0 : slackBotMedium.channels) || []);
    } else {
      validationHook.handleChange(validationHook.names.slackAppChannels, []);
    }

    if (teamsBotMedium && !(0, _lodash.isEmpty)(teamsBotMedium)) {
      validationHook.handleChange(validationHook.names.teamsAppChannels, (teamsBotMedium === null || teamsBotMedium === void 0 ? void 0 : teamsBotMedium.teamsAppChannels) || []);
    } else {
      validationHook.handleChange(validationHook.names.teamsAppChannels, []);
    }
  }, [selectedNotificationMediums]);

  var closeDrawer = function closeDrawer() {
    setIsDrawerOpen(false);
    setSelectionError(null);
    setCurrentEditingMedium({});
    dispatch((0, _actions.flushGetIDsData)());
  };

  var validateChannels = function validateChannels(notificationMedium) {
    setSelectionError(null);
    dispatch((0, _actions.validateChannelList)(notificationMedium.id, notificationMedium.channels));
  };

  var handleAddNotification = function handleAddNotification(notificationMedium) {
    setSelectionError(null);
    addHandler(notificationMedium);
  };

  var addHandler = function addHandler(notificationMedium) {
    if (!(0, _lodash.isEmpty)(notificationMedium)) {
      var updatedNotificationMediums; // Find and update the same slack object.

      if (!(0, _lodash.isEmpty)(currentEditingMedium) && ((0, _utils.isSlack)(notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.type) || (notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.type) === _constants.formConstants.slackbotText)) {
        var slackMediumIndex = selectedNotificationMediums.findIndex(function (data) {
          return data.id === currentEditingMedium.id;
        });
        updatedNotificationMediums = (0, _lodash.clone)(selectedNotificationMediums);

        if (slackMediumIndex !== -1) {
          updatedNotificationMediums[slackMediumIndex] = notificationMedium;
        }
      } else if (!(0, _lodash.isEmpty)(currentEditingMedium) && (notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.type) === _constants.formConstants.teamsbotText) {
        var index = selectedNotificationMediums.findIndex(function (data) {
          return data.id === currentEditingMedium.id;
        });
        updatedNotificationMediums = (0, _lodash.clone)(selectedNotificationMediums);

        if (index !== -1) {
          updatedNotificationMediums[index] = notificationMedium;
        }
      } else {
        updatedNotificationMediums = [].concat(_toConsumableArray(selectedNotificationMediums), [notificationMedium]);
      }

      setSelectedNotificationMediums(updatedNotificationMediums);
      validationHook.handleChange(validationHook.names.notificationMedium, updatedNotificationMediums);
    }

    closeDrawer();
  };

  var handleDelete = function handleDelete(id) {
    var filteredData = selectedNotificationMediums === null || selectedNotificationMediums === void 0 ? void 0 : selectedNotificationMediums.filter(function (notificationMedium) {
      return (notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.id) !== id;
    });
    setSelectedNotificationMediums(filteredData);
    validationHook.handleChange(validationHook.names.notificationMedium, filteredData);
  };

  var handleDayFocus = function handleDayFocus(e) {
    var _validationHook$value10;

    if (!((_validationHook$value10 = validationHook.values) !== null && _validationHook$value10 !== void 0 && _validationHook$value10.validForDays)) {
      e.target.value = '00';
    }
  };

  var handleDayBlur = function handleDayBlur(e) {
    if (e.target.value === '00') {
      e.target.value = null;
    }

    validationHook.handleBlur(validationHook.names.validForDays);
  };

  var handleHoursMinutesFocus = function handleHoursMinutesFocus(e, changedValue) {
    if (!changedValue) {
      e.target.value = '00:00';
    }
  };

  var handleHoursMinutesBlur = function handleHoursMinutesBlur(e, fieldName) {
    if (e.target.value === '00:00') {
      e.target.value = null;
    }

    validationHook.handleBlur(fieldName);
  };

  var closeMembersModal = function closeMembersModal() {
    setMembersTagId(null);
    setMembersModalTitle(null);
    setSelectionError(null);
    dispatch((0, _actions2.resetTagMembersRequest)());
  };

  var tableProps = {
    rows: selectedNotificationMediums,
    columns: [{
      field: 'name',
      width: '240px',
      headerName: 'Name',
      sortable: true
    }, {
      field: 'description',
      headerName: 'Description',
      width: '240px',
      sortable: true
    }, {
      field: 'application',
      width: '200px',
      headerName: 'Application',
      sortable: true,
      renderColumn: function renderColumn(row) {
        if (row.type === _constants.formConstants.slackbotText) {
          return 'Slack Application';
        }

        if (row.type === _constants.formConstants.teamsbotText) {
          return 'Teams Application';
        }

        return (0, _lodash.startCase)(row === null || row === void 0 ? void 0 : row.type);
      }
    }, {
      field: 'channels',
      width: '300px',
      headerName: 'Channel(s)',
      sortable: true,
      renderColumn: function renderColumn(row) {
        if ((row === null || row === void 0 ? void 0 : row.type) === _constants.formConstants.teamsbotText) {
          var pillList = (row.teamsAppChannels || []).map(function (channel) {
            var team = channel.team || 'none';
            var channels = channel.channels || [];
            return "".concat(team, ": ").concat(channels.join(', '));
          });
          return /*#__PURE__*/_react.default.createElement(_index.default, {
            data: pillList || [],
            maxWidth: 400,
            modalTitle: "".concat(row.name, " Associations")
          });
        } else {
          return !(0, _lodash.isEmpty)(row === null || row === void 0 ? void 0 : row.channels) && /*#__PURE__*/_react.default.createElement(_typography.default, {
            variant: "label1"
          }, " ", row === null || row === void 0 ? void 0 : row.channels.toString(), " ");
        }
      }
    }, {
      headerName: 'Actions',
      width: '120px',
      renderColumn: function renderColumn(row) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "action-icons-container"
        }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
          title: 'Delete',
          position: "top"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "action-icon",
          onClick: function onClick() {
            handleDelete(row.id);
          }
        }, /*#__PURE__*/_react.default.createElement(_bs.BsTrash, {
          size: 24
        }))), ((0, _utils.isSlack)(row === null || row === void 0 ? void 0 : row.type) || row.type === _constants.formConstants.slackbotText || row.type === _constants.formConstants.teamsbotText) && /*#__PURE__*/_react.default.createElement(_tooltip.default, {
          title: 'Edit',
          position: "top"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "action-icon",
          onClick: function onClick() {
            setCurrentEditingMedium(row);
            setIsDrawerOpen(true);
            setSelectionError(null);
          }
        }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
          src: _edit.default,
          className: "action-icon-edit"
        })))));
      }
    }],
    resizableColumns: true
  };
  var userColumns = [{
    field: 'firstName',
    headerName: 'First Name',
    sortable: true
  }, {
    field: 'lastName',
    headerName: 'Last Name',
    sortable: true
  }, {
    field: 'username',
    headerName: 'Username',
    sortable: true
  }, {
    field: 'email',
    headerName: 'Email',
    sortable: true
  }, {
    headerName: 'Action',
    width: '80px',
    renderColumn: function renderColumn(row) {
      return /*#__PURE__*/_react.default.createElement(_bs.BsTrash, {
        size: 24,
        onClick: function onClick() {
          var _validationHook$value11;

          var updatedUsers = (_validationHook$value11 = validationHook.values.userList) === null || _validationHook$value11 === void 0 ? void 0 : _validationHook$value11.filter(function (user) {
            return user.username !== row.username;
          });
          validationHook.handleChange(validationHook.names.userList, updatedUsers);
        }
      });
    }
  }];
  var tagColumns = [{
    field: 'name',
    headerName: 'Name',
    sortable: true
  }, {
    field: 'description',
    headerName: 'Description',
    sortable: true
  }, {
    headerName: 'Members',
    sortable: true,
    renderColumn: function renderColumn(row) {
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex'
        }
      }, row.userCount, "\xA0", /*#__PURE__*/_react.default.createElement(_button.default, {
        variant: "textOnly",
        size: "small",
        onClick: function onClick() {
          setMembersTagId(row.userTagId);
          setMembersModalTitle(row.name);
        }
      }, row.userCount > 0 ? /*#__PURE__*/_react.default.createElement(_fa.FaSearch, {
        color: _commonUtils.blue60
      }) : null));
    }
  }, {
    headerName: 'Action',
    width: '80px',
    renderColumn: function renderColumn(row) {
      return /*#__PURE__*/_react.default.createElement(_bs.BsTrash, {
        size: 24,
        onClick: function onClick() {
          var _validationHook$value12;

          var updatedTags = (_validationHook$value12 = validationHook.values.tagList) === null || _validationHook$value12 === void 0 ? void 0 : _validationHook$value12.filter(function (tag) {
            return tag.userTagId !== row.userTagId;
          });
          validationHook.handleChange(validationHook.names.tagList, updatedTags);
        }
      });
    }
  }];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.stepperMainContainer
  }, consumer !== _commonConstants.papServiceConsumer && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", translatedStrings.accessType, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldValueWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, " ", validationHook.values.allowDeny, " "))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_radio.default, {
    label: translatedStrings.approvalLabel,
    defaultValue: "".concat(validationHook.values.isApprovals + ''),
    name: "isApprovals",
    options: [{
      label: translatedStrings.yesLabel,
      value: 'true'
    }, {
      label: translatedStrings.noLabel,
      value: 'false'
    }],
    direction: "vertical",
    onChange: function onChange(e) {
      var value = e.target.value === 'true';
      validationHook.handleChange(validationHook.names.isApprovals, value);

      if (e.target.value === 'false') {
        setSelectedNotificationMediums([]);
        validationHook.handleChange(validationHook.names.notificationMedium, []);
        validationHook.handleChange(validationHook.names.userList, []);
        validationHook.handleChange(validationHook.names.tagList, []);
        validationHook.handleChange(validationHook.names.channelList, []);
        validationHook.handleChange(validationHook.names.approvalMaxTime, '');
        validationHook.handleChange(validationHook.names.validFor, '');
        validationHook.handleChange(validationHook.names.validForDays, '');
        validationHook.handleChange(validationHook.names.teamsAppChannels, []);
        validationHook.handleChange(validationHook.names.required, false);
        validationHook.handleChange(validationHook.names.condition, _constants.formConstants.Any);
      }
    }
  })), validationHook.values.isApprovals && !resourcesLoading && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.fieldContainer
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, "Notifications")), /*#__PURE__*/_react.default.createElement(_button.default, {
    size: 'medium',
    onClick: function onClick() {
      setIsDrawerOpen(true);
      setSelectionError(null);
    }
  }, "Add Notification"), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.valueWrapper
  }, !(0, _lodash.isEmpty)(selectedNotificationMediums) && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.notificationTableContainer
  }, /*#__PURE__*/_react.default.createElement(_table.default, tableProps)))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: '16px'
    }
  }, /*#__PURE__*/_react.default.createElement(_SectionTitle.default, {
    title: "Manager Approval Settings"
  })), /*#__PURE__*/_react.default.createElement(_checkbox.default, {
    name: "approvalMandatory",
    label: "Manager Approval",
    checked: validationHook.values.required,
    onChange: function onChange(e) {
      var isChecked = e.target.checked;
      validationHook.handleChange(validationHook.names.required, isChecked); // Reset condition to 'Any' if checkbox is unchecked

      var currentValue = !isChecked ? _constants.formConstants.Any : validationHook.values.condition;
      validationHook.handleChange(validationHook.names.condition, currentValue);
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginLeft: '24px',
      marginTop: '16px'
    }
  }, /*#__PURE__*/_react.default.createElement(_radio.default, {
    name: "approvalType",
    direction: "vertical",
    label: "",
    defaultValue: !validationHook.values.required ? '' : validationHook.values.condition,
    onChange: function onChange(e) {
      var selectedValue = e.target.value;
      var isUsersTagsEmpty = (0, _lodash.isEmpty)(validationHook.values.tagList) && (0, _lodash.isEmpty)(validationHook.values.userList);

      if (selectedValue === _constants.formConstants.Manager && !isUsersTagsEmpty) {
        setDialogOpen(true);
        return;
      }

      validationHook.handleChange(validationHook.names.condition, selectedValue);
    },
    options: [{
      label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Manager ", /*#__PURE__*/_react.default.createElement("strong", null, "OR"), " Approvers"),
      value: _constants.formConstants.Any,
      disabled: !validationHook.values.required
    }, {
      label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Manager ", /*#__PURE__*/_react.default.createElement("strong", null, "AND"), " Approvers"),
      value: _constants.formConstants.All,
      disabled: !validationHook.values.required
    }, {
      label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Manager ", /*#__PURE__*/_react.default.createElement("strong", null, "Only")),
      value: _constants.formConstants.Manager,
      disabled: !validationHook.values.required
    }]
  }))), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.fieldContainer
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, "Users")), /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    onClick: function onClick() {
      return setAddUsersModalVisibility(true);
    },
    disabled: validationHook.values.condition === _constants.formConstants.Manager
  }, "Select Users"), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.notificationTableContainer
  }, /*#__PURE__*/_react.default.createElement(_DataTable.default, {
    rows: validationHook.values.userList,
    columns: userColumns
  })), /*#__PURE__*/_react.default.createElement(_AddIdentities.default, {
    translatedStrings: translatedStrings,
    identityType: translatedStrings.userLabel,
    showModal: addUsersModalVisibility,
    onModalClose: setAddUsersModalVisibility,
    updateSelection: function updateSelection(updatedUsers) {
      validationHook.handleChange(validationHook.names.userList, updatedUsers);
    },
    selectedData: validationHook.values.userList
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: styles.fieldContainer
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, "Tags")), /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    onClick: function onClick() {
      return setAddTagModalVisibility(true);
    },
    disabled: validationHook.values.condition === _constants.formConstants.Manager
  }, "Select Tags"), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.notificationTableContainer
  }, /*#__PURE__*/_react.default.createElement(_DataTable.default, {
    rows: validationHook.values.tagList,
    columns: tagColumns
  })), /*#__PURE__*/_react.default.createElement(_AddTags.default, {
    showModal: addTagModalVisibility,
    onModalClose: setAddTagModalVisibility,
    translatedStrings: translatedStrings,
    updateSelection: function updateSelection(updatedTags) {
      validationHook.handleChange(validationHook.names.tagList, updatedTags);
    },
    selectedData: validationHook.values.tagList
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_textfield.default, {
    type: "text",
    width: _constants.fieldWidth,
    label: /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.infoIcon
    }, translatedStrings.approverTime, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: maximumTimeToApproveInfoMessage,
      position: "right"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _infoIcon.default
    }))),
    helperText: translatedStrings.hhmm,
    value: validationHook.values.approvalMaxTime,
    onChange: function onChange(e) {
      return validationHook.handleChange(validationHook.names.approvalMaxTime, e.target.value);
    },
    onFocus: function onFocus(e) {
      return handleHoursMinutesFocus(e, validationHook.values.approvalMaxTime);
    },
    onBlur: function onBlur(e) {
      return handleHoursMinutesBlur(e, validationHook.names.approvalMaxTime);
    },
    error: validationHook.touched.approvalMaxTime && Boolean(validationHook.errors.approvalMaxTime),
    errorMsg: validationHook.errors.approvalMaxTime
  })), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.infoIcon
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, translatedStrings.accessValidityAfterApprovalLabel), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    title: approvalValidityInfoMessage,
    position: "right"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _infoIcon.default
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingTop: 25
    }
  }, /*#__PURE__*/_react.default.createElement(_radio.default, {
    defaultValue: validationHook.values.isValidForInDays ? 'days' : 'hours',
    name: "isValidForInDays",
    options: [{
      label: translatedStrings.days,
      value: 'days'
    }, {
      label: translatedStrings.hhmm,
      value: 'hours'
    }],
    direction: "vertical",
    onChange: function onChange(e) {
      validationHook.handleChange(validationHook.names.validFor, '');
      validationHook.handleChange(validationHook.names.validForDays, '');
      validationHook.handleChange(validationHook.names.isValidForInDays, e.target.value === 'days');
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginLeft: '16px'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingTop: '5px'
    }
  }, /*#__PURE__*/_react.default.createElement(_textfield.default, {
    type: "text",
    width: '94px',
    disabled: !validationHook.values.isValidForInDays,
    value: validationHook.values.validForDays,
    onChange: function onChange(e) {
      var value = e.target.value.replace(/[^0-9]/g, '');
      validationHook.handleChange(validationHook.names.validForDays, value);
      validationHook.handleChange(validationHook.names.validFor, '');
    },
    onFocus: handleDayFocus,
    onBlur: handleDayBlur,
    error: validationHook.touched.validForDays && Boolean(validationHook.errors.validForDays),
    errorMsg: validationHook.errors.validForDays
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      paddingTop: '5px'
    }
  }, /*#__PURE__*/_react.default.createElement(_textfield.default, {
    type: "text",
    width: '94px',
    disabled: validationHook.values.isValidForInDays,
    value: validationHook.values.isValidForInDays ? '' : validationHook.values.validFor,
    onChange: function onChange(e) {
      validationHook.handleChange(validationHook.names.validFor, e.target.value);
      validationHook.handleChange(validationHook.names.validForDays, '');
    },
    onFocus: function onFocus(e) {
      return handleHoursMinutesFocus(e, validationHook.values.validFor);
    },
    onBlur: function onBlur(e) {
      return handleHoursMinutesBlur(e, validationHook.names.validFor);
    },
    error: validationHook.touched.validFor && Boolean(validationHook.errors.validFor),
    errorMsg: validationHook.errors.validFor
  }))))), isDrawerOpen && /*#__PURE__*/_react.default.createElement(_NotificationMediumSelector.default, {
    onCancel: closeDrawer,
    onAdd: handleAddNotification,
    error: selectionError,
    selectedNotificationMediums: selectedNotificationMediums,
    notificationMediumOptions: notificationMediumOptions,
    selectedMedium: currentEditingMedium,
    validateChannels: validateChannels,
    isFromAllSecrets: isFromAllSecrets
  }), membersTagId ? /*#__PURE__*/_react.default.createElement(_modalPopup.default, {
    width: '50%',
    title: membersModalTitle,
    onCancel: closeMembersModal,
    buttons: [{
      text: translatedStrings.cancelBtn,
      variant: 'secondary',
      onClick: closeMembersModal,
      size: 'large'
    }]
  }, /*#__PURE__*/_react.default.createElement(_TagMembers.default, {
    tagId: membersTagId
  })) : null, dialogOpen && /*#__PURE__*/_react.default.createElement(_dialog.default, {
    width: 464,
    height: 278,
    type: "alert",
    title: '',
    message: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "With ", /*#__PURE__*/_react.default.createElement("strong", null, "Manager Only"), " approval selected, any Approvers(Users/Tags) assigned will not be part of the approval flow."),
    primaryButtonText: 'Ok',
    onSubmit: function onSubmit() {
      setDialogOpen(false);
      validationHook.handleChange(validationHook.names.condition, _constants.formConstants.Manager);
    },
    onCancel: function onCancel() {
      var _validationHook$value13;

      var newValue = ((_validationHook$value13 = validationHook.values) === null || _validationHook$value13 === void 0 ? void 0 : _validationHook$value13.condition) || _constants.formConstants.Any;
      validationHook.handleChange(validationHook.names.condition, newValue);
      setDialogOpen(false);
    }
  })));
};

Approvals.propTypes = {
  validationHook: _propTypes.default.object,
  usersDataStatus: _propTypes.default.string,
  usersData: _propTypes.default.array,
  initSpinnerOverlay: _propTypes.default.func,
  groupsDataStatus: _propTypes.default.string,
  groupsData: _propTypes.default.array,
  isEditMode: _propTypes.default.bool,
  isCloneMode: _propTypes.default.bool,
  recursiveApprovalChannelListLoading: _propTypes.default.func,
  recursiveApprovalChannelListRequest: _propTypes.default.func,
  recursiveApprovalChannelListReset: _propTypes.default.func,
  notificationMediumStatus: _propTypes.default.string,
  notificationMediumData: _propTypes.default.array,
  channelListStatus: _propTypes.default.string,
  channelListData: _propTypes.default.array,
  dispatch: _propTypes.default.func,
  translatedStrings: _propTypes.default.object,
  consumer: _propTypes.default.string,
  isFromAllSecrets: _propTypes.default.bool,
  openNotification: _propTypes.default.func
};
var _default = Approvals;
exports.default = _default;